import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/features/login/Login.page';
import User from '@/features/user/User.page';
import store from '@/store';
/* Async routes */
const UserDashboard = () => import('@/features/user-dashboard/UserDashboard.vue');
const Operation = () => import('@/features/operation/Operation.vue');
const NewOperation = () => import('@/features/operation-new/NewOperation.vue');
const Juridico = () => import('@/features/juridico/Juridico.vue');
const Analisis = () => import('@/features/analisis/Analisis.vue');
const Financiero = () => import('@/features/financiero/Financiero.vue');
const MenuOperation = () => import('@/features/menu-operaciones/MenuOperaciones.vue');
const MenuCesion = () => import('@/features/menu-cesiones/MenuCesiones.vue');
const MenuCliente = () => import('@/features/menu-clientes/MenuClientes.vue');
const MenuInforme = () => import('@/features/menu-informes/MenuInformes.vue');
const MenuInversores = () => import('@/features/menu-inversores/MenuInversores.vue');
const MenuColaboradores = () => import('@/features/menu-colaboradores/MenuColaboradores.vue');
const NewInversor = () => import('@/features/menu-inversores/containers/NewInversor.vue');
const EditInversor = () => import('@/features/menu-inversores/containers/EditInversor.vue');
const SearchInversor = () => import('@/features/menu-inversores/containers/SearchInversor.vue');
const Admin = () => import('@/features/admin/Admin.vue');
const Propuesta = () => import('@/features/propuesta-no-vinculante/PropuestaContainer.vue');
const FichaComercial = () => import('@/features/ficha-comercial/FichaComercial.vue');
const Cesiones = () => import('@/features/cesiones/Cesiones.vue');
const FichaInversion = () => import('@/features/cesiones/containers/FichaInversion.vue');
const NuevaCesion = () => import('@/features/cesiones/containers/NuevaCesion.vue');
const SancionRiesgos = () => import('@/features/sancion-riesgos/SancionRiesgos');
const Formalizacion = () => import('@/features/formalizacion/Formalizacion');
const PostFirma = () => import('@/features/post-firma/PostFirma');
const Cancelacion = () => import('@/features/cancelacion/Cancelacion');
const GestionInmobiliaria = () => import('@/features/gestion-inmobiliaria/GestionInmobiliaria');
const SearchClient = () => import('@/features/menu-clientes/containers/SearchClient');
const NewClient = () => import('@/features/menu-clientes/containers/NewClient');
const UpdateClient = () => import('@/features/menu-clientes/containers/UpdateClient');
const RenovarCesion = () => import('@/features/cesiones/containers/RenovacionCesion');
const EditarCesion = () => import('@/features/cesiones/containers/EditCesion');
const RecompraCesion = () => import('@/features/cesiones/containers/RecompraCesion');
const MenuFichaInmobiliaria = () => import('@/features/menu-ficha-inmobiliaria/MenuFichaInmobiliaria');
const MenuFichaComercial = () => import('@/features/menu-ficha-comercial/MenuFichaComercial');
const Renovacion = () => import('@/features/renovacion/Renovacion');

Vue.use(Router);

async function redirectIfNotAuth(to, from, next) {
  const user = await store.getters.user;
  const isLoggedIn = await store.getters.isLogged;
  if (!isLoggedIn || !user || !user.name) {
    next({ name: 'login' });
  } else {
    next();
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/user/:id',
      name: 'user',
      component: User,
      beforeEnter: redirectIfNotAuth,
      children: [
        {
          path: 'dashboard',
          name: 'user-dashboard',
          component: UserDashboard,
        },
        {
          path: 'operation',
          name: 'operation',
          component: Operation,
          children: [
            {
              path: 'new',
              name: 'operation-new',
              component: NewOperation,
            },
            {
              path: 'cesiones/:opid',
              name: '',
              component: Cesiones,
              children: [
                {
                  path: '',
                  name: 'ficha-inversion',
                  component: FichaInversion,
                },
                {
                  path: 'nueva',
                  name: 'nueva-cesion',
                  component: NuevaCesion,
                },
                {
                  path: 'renovar/:idCesion',
                  name: 'renovar-cesion',
                  component: RenovarCesion,
                },
                {
                  path: 'editar/:idCesion',
                  name: 'editar-cesion',
                  component: EditarCesion,
                },
                {
                  path: 'recomprar/:idCesion',
                  name: 'recomprar-cesion',
                  component: RecompraCesion,
                },
              ],
            },
            {
              path: 'analisis/:opid',
              name: 'analisis',
              component: Analisis,
            },
            {
              path: 'juridico/:opid',
              name: 'juridico',
              component: Juridico,
            },
            {
              path: 'renovacion/:opid',
              name: 'renovacion',
              component: Renovacion,
            },
            {
              path: 'financiero/:opid',
              name: 'financiero',
              component: Financiero,
            },
            {
              path: 'riesgos/:opid',
              name: 'sancion-riesgos',
              component: SancionRiesgos,
            },
            {
              path: 'propuesta/:opid',
              name: 'propuesta',
              component: Propuesta,
            },
            {
              path: 'formalizacion/:opid',
              name: 'formalizacion',
              component: Formalizacion,
            },
            {
              path: 'post-firma/:opid',
              name: 'post-firma',
              component: PostFirma,
            },
            {
              path: 'cancelacion/:opid',
              name: 'cancelacion',
              component: Cancelacion,
            },
            {
              path: 'ficha-comercial/:opid',
              name: 'ficha-comercial',
              component: FichaComercial,
            },
            {
              path: 'gestion-inmobiliaria/:opid',
              name: 'gestion-inmobiliaria',
              component: GestionInmobiliaria,
            },
          ],
        },
        {
          path: 'buscar-operacion',
          name: 'buscar-operacion',
          component: MenuOperation,
        },
        {
          path: 'buscar-cesion',
          name: 'buscar-cesion',
          component: MenuCesion,
        },
        {
          path: 'cliente',
          name: 'cliente',
          component: MenuCliente,
          children: [
            {
              path: 'nuevo',
              name: 'crear-cliente',
              component: NewClient,
            },
            {
              path: 'perfil/:cid',
              name: 'perfil',
              component: UpdateClient,
            },
            {
              path: 'buscar-cliente',
              name: 'buscar-cliente',
              component: SearchClient,
            },
          ],
        },
        {
          path: 'colaboradores',
          name: 'colaboradores',
          component: MenuColaboradores,
        },
        {
          path: 'menu-ficha-comercial',
          name: 'menu-ficha-comercial',
          component: MenuFichaComercial,
        },
        {
          path: 'menu-ficha-inmobiliaria',
          name: 'menu-ficha-inmobiliaria',
          component: MenuFichaInmobiliaria,
        },
        {
          path: 'inversores',
          name: 'inversores',
          component: MenuInversores,
          children: [
            {
              path: 'nuevo',
              name: 'nuevo-inversor',
              component: NewInversor,
            },
            {
              path: 'inversor/:inversor',
              name: 'edit-inversor',
              component: EditInversor,
            },
            {
              path: 'buscar',
              name: 'buscar-inversor',
              component: SearchInversor,
            },
          ],
        },
        {
          path: 'buscar-informe',
          name: 'buscar-informe',
          component: MenuInforme,
        },
        {
          path: 'admin',
          name: 'admin',
          component: Admin,
        },
      ],
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js